import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "../pages/auth/LoginPage";
import RecuperarClavePage from "../pages/auth/RecuperarClavePage";
import DashboardPage from "../pages/DashboardPage";
import MovimientosPage from "../pages/MovimientosPage";
import CuentasPage from "../pages/CuentasPage";
import PresupuestosPage from "../pages/PresupuestosPage";
import MetasPage from "../pages/MetasPage";
import DeudasPage from "../pages/DeudasPage";
import CuentasCobrarPage from "../pages/CuentasCobrarPage";
import CuentasPagarPage from "../pages/CuentasPagarPage";
import ReportesPage from "../pages/ReportesPage";
import UsuariosPage from "../pages/UsuariosPage";
import ConfiguracionPage from "../pages/ConfiguracionPage";
import AuditoriaPage from "../pages/AuditoriaPage";
import ProtectedRoute from "../components/common/ProtectedRoute";
import MiPerfilPage from "../pages/MiPerfilPage";


export default function AppRouter() {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/recuperar-clave" element={<RecuperarClavePage />} />

            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <DashboardPage />
                    </ProtectedRoute>
                }
            />
            <Route path="/movimientos" element={<ProtectedRoute><MovimientosPage /></ProtectedRoute>} />
            <Route path="/cuentas" element={<ProtectedRoute><CuentasPage /></ProtectedRoute>} />
            <Route path="/presupuestos" element={<ProtectedRoute><PresupuestosPage /></ProtectedRoute>} />
            <Route path="/metas" element={<ProtectedRoute><MetasPage /></ProtectedRoute>} />
            <Route path="/deudas" element={<ProtectedRoute><DeudasPage /></ProtectedRoute>} />
            <Route path="/cuentas-cobrar" element={<ProtectedRoute><CuentasCobrarPage /></ProtectedRoute>} />
            <Route path="/cuentas-pagar" element={<ProtectedRoute><CuentasPagarPage /></ProtectedRoute>} />
            <Route path="/reportes" element={<ProtectedRoute><ReportesPage /></ProtectedRoute>} />
            <Route path="/usuarios" element={<ProtectedRoute><UsuariosPage /></ProtectedRoute>} />
            <Route path="/configuracion" element={<ProtectedRoute><ConfiguracionPage /></ProtectedRoute>} />
            <Route path="/auditoria" element={<ProtectedRoute><AuditoriaPage /></ProtectedRoute>} />
            <Route path="/mi-perfil" element={<ProtectedRoute><MiPerfilPage /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}